import { toastActions } from "src/design-system/Toast/utils";
import { FEATURE_FLAGS } from "src/router/featureFlags";

type CaseAnalyticsModules = {
  isAnalyticsModuleEnabled: boolean;
  isCaseManagementEnabled: boolean;
};

/**
 * Blocks activating the case-analytics URL flag when required modules are off.
 * Returns the unchanged params when blocked; null when activation may proceed.
 */
export const guardCaseAnalyticsFlag = (
  flagValue: string,
  searchParams: URLSearchParams,
  modules: CaseAnalyticsModules,
): URLSearchParams | null => {
  if (
    flagValue !== FEATURE_FLAGS.caseAnalytics ||
    searchParams.has(flagValue)
  ) {
    return null;
  }

  if (!modules.isAnalyticsModuleEnabled) {
    toastActions.failure({
      title: "Analytics module required",
      description:
        "Enable the Analytics module before activating case analytics.",
    });
    return searchParams;
  }

  if (!modules.isCaseManagementEnabled) {
    toastActions.failure({
      title: "Case Management module required",
      description:
        "Enable the Case Management module before activating case analytics.",
    });
    return searchParams;
  }

  return null;
};
